export { default as getOwaResourceUrl } from './getOwaResourceUrl';
export { default as getOwaResourceImageUrl } from './getOwaResourceImageUrl';
